import { BindAll } from 'lodash-decorators'
import { PagePagination } from '@xt/client/utils/infinite-loading/index'
import { EnumApiTicket } from '@xt/client/api'
import { EnumApiCoupon } from '@xt/client/api/coupon'
import type { ExchangeProductItem } from '@xt/client/entities/ticket/product.d'
import type { ExchangeRecordResponse } from '@xt/client/entities/my-v2/types.d'

@BindAll()
export class MyAccountExchangeController {
  // 兑换记录分页
  recordPagePagination = new PagePagination<ExchangeRecordResponse>({
    url: EnumApiCoupon.ExchangeRecode,
    mapValues: res => {
      const { data } = res
      return {
        dataSource: data
      }
    }
  })

  // 优惠券列表分页
  ticketPagePagination = new PagePagination<ExchangeProductItem>({
    url: EnumApiTicket.TICKET_LIST
  })
}
